<template>
    <div class="login-page">
        <a href="/screens" class="login-page-nav">Карта экранов</a>
        <div class="login-wrapper">
            <div class="login-container">
                <div class="login-card">
                <div class="login-header">
                    <img src="/images/2digital-horis.png" alt="2Digital" class="login-logo" />
                </div>

                <form @submit.prevent="handleSubmit" action="/login" method="POST" class="login-form">
                    <input type="hidden" name="_token" :value="csrf" />

                    <div class="form-group">
                        <label for="email" class="form-label">Email</label>
                        <input id="email" type="email" name="email" v-model="email" class="form-input"
                            placeholder="your@2digital.dooh" autocomplete="email" required
                            :class="{ 'error': hasErrors && !email }" />
                    </div>

                    <div class="form-group">
                        <label for="password" class="form-label">Пароль</label>
                        <input id="password" type="password" name="password" v-model="password" class="form-input"
                            placeholder="••••••••" autocomplete="current-password" required
                            :class="{ 'error': hasErrors && !password }" />
                    </div>

                    <div v-if="successMessage" class="success-message">
                        {{ successMessage }}
                    </div>

                    <div v-if="errorMessage" class="error-message">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8 5.33333V8M8 10.6667H8.00667M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        {{ errorMessage }}
                    </div>

                    <button type="submit" class="login-button" :disabled="isLoading || !email || !password"
                        :class="{ 'loading': isLoading }">
                        <span v-if="!isLoading">Войти</span>
                        <span v-else class="button-loader"></span>
                    </button>

                    <p class="login-footer-link">
                        Нет аккаунта?
                        <a href="/register">Регистрация</a>
                    </p>
                </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            errorMessage: '',
            successMessage: '',
            isLoading: false,
            hasErrors: false,
            csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        };
    },
    mounted() {
        // Проверяем наличие ошибок валидации из Laravel
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('error')) {
            this.errorMessage = 'Неверный email или пароль';
            this.hasErrors = true;
        }
        if (urlParams.has('registered')) {
            this.successMessage = 'Регистрация принята. Вход будет доступен после одобрения администратором.';
        }
    },
    methods: {
        async handleSubmit(event) {
            this.errorMessage = '';
            this.hasErrors = false;
            this.isLoading = true;

            try {
                const formData = new FormData(event.target);
                const response = await fetch('/login', {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': this.csrf,
                    },
                    body: formData,
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.redirect_url) {
                        window.location.href = data.redirect_url;
                    } else {
                        window.location.href = '/';
                    }
                } else {
                    const data = await response.json().catch(() => ({}));
                    if (data.errors) {
                        const errors = Object.values(data.errors).flat();
                        this.errorMessage = errors[0] || 'Ошибка входа';
                    } else if (data.message) {
                        this.errorMessage = data.message;
                    } else {
                        this.errorMessage = 'Неверный email или пароль';
                    }
                    this.hasErrors = true;
                }
            } catch (error) {
                this.errorMessage = 'Произошла ошибка. Попробуйте еще раз.';
                this.hasErrors = true;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
